import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FinancialRoutingModule } from './financial.routing';

@NgModule({
  declarations: [],
  imports: [CommonModule, FinancialRoutingModule, SharedModule]
})
export class FinancialModule {}
